import { PLANS as _PLANS } from './plans';
import { FEATURES as _FEATURES } from './features';

const hideFirstPlan = true; // hide first plan from PLANS

const PLANS = [ ..._PLANS ];
const FEATURES = _FEATURES.map(item => {
  const newItem = { ...item };
  newItem.value = [ ...item.value ];
  return newItem;
});
if (hideFirstPlan) {
  PLANS.splice(0, 1);
  FEATURES.forEach(item => item.value.splice(0, 1));
}
const FEATURES_PLANS = {
  PLANS,
  FEATURES,
  MIN_PRICE: PLANS[0].price.annual,
};

export default FEATURES_PLANS;
